const DomainType = {
  DOMAIN_EMAIL: 1,
  USER_EMAIL: 2
}
export default DomainType
